<template>
  <bm-number v-if="readOnly" :t="t" :value="value" read-only />
  <v-container
    v-else
    fluid
    class="bm-slider pa-0"
    :class="{ 'bm-slider-error': errorMessages }"
  >
    <v-layout row>
      <label
        aria-hidden="true"
        :class="{
          'v-label': true,
          'theme--light': true,
          'error--text': errorMessages && errorMessages.length,
        }"
        style="left: 0px; right: auto; position: relative"
        >{{ labelVal }}</label
      >
    </v-layout>
    <v-layout row>
      <v-flex grow>
        <v-slider
          v-bind="$attrs"
          :label="min?.toString() ?? ''"
          :min="min"
          :max="max"
          :value="value"
          :error-messages="errorMessages"
          :disabled="$attrs.loading || $attrs.disabled"
          @input="handleEvent($event)"
        >
        </v-slider>
      </v-flex>
      <v-flex shrink class="bm-slider-label">
        <v-label class="error--text">{{ max }}</v-label>
      </v-flex>
      <v-flex shrink class="bm-slider-text-flex">
        <bm-number
          width="20px"
          :value="value"
          class="mt-0 bm-slider-text"
          type="number"
          :min="min"
          :max="max"
          hide-details
          single-line
          color="brand02"
          :error-messages="errorMessages"
          :loading="$attrs.loading"
          :disabled="$attrs.loading || $attrs.disabled"
          @input="handleEvent($event)"
          @mouseover="setFocused(true)"
          @mouseout="setFocused(false)"
          @focus="bubbleEvent($event)"
          @blur="bubbleEvent($event)"
        >
          <template v-if="tooltipVal" #append-outer>
            <bm-tooltip bottom>
              <template #activator="{ on }">
                <v-icon small v-on="on">info</v-icon>
              </template>
              <span>{{ tooltipVal }}</span>
            </bm-tooltip>
          </template>
        </bm-number>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script lang="ts">
import BmTooltip from "@/components/controls/input/BmTooltip.vue";
import BmLabelled from "@/components/controls/input/mixins/BmLabelled";
import BmInputField from "@/components/controls/input/mixins/BmInputField";
import { DisplayHelpers } from "@/components/mixins/DisplayHelpers";
import type { PropType } from "vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "BmSlider",
  components: { BmTooltip },
  mixins: [BmLabelled, BmInputField, DisplayHelpers],
  inheritAttrs: false,
  props: {
    readOnly: {
      type: Boolean,
      required: false,
    },
    value: {
      type: Number,
      required: false,
    },
    min: {
      type: Number,
      required: false,
    },
    max: {
      type: Number,
      required: false,
    },
    errorMessages: {
      type: Array as PropType<string[]>,
      required: false,
    },
  },
  methods: {
    handleEvent(val: string) {
      this.$emit("input", +val);
    },
  },
});
</script>

<style lang="sass">
@import "src/sass/colours"

.bm-slider-label label
  top: 23px

.bm-slider .layout
  margin-left: 0 !important

// need to set validation error color on our extra label
.bm-slider-error .bm-slider-label label
  color: $bm-color-error-text

// TODO - make the right text field not a fixed size as it breaks when using more than 3 numbers
.bm-slider-text-flex
  width: 90px

.bm-slider-text
  padding-top: 15px
</style>
